var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.75C0 2.12665 2.12665 0 4.75 0H11.25C13.8734 0 16 2.12665 16 4.75V11.25C16 13.8734 13.8734 16 11.25 16H4.75C2.12665 16 0 13.8734 0 11.25V4.75ZM4.75 1.5C2.95508 1.5 1.5 2.95507 1.5 4.75V11.25C1.5 13.0449 2.95508 14.5 4.75 14.5H11.25C13.0449 14.5 14.5 13.0449 14.5 11.25V4.75C14.5 2.95507 13.0449 1.5 11.25 1.5H4.75Z",
    fill: "#9E9FA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41922 8.4114C4.23299 8.04325 3.78401 7.89447 3.41459 8.07918C3.04411 8.26442 2.89394 8.71493 3.07918 9.08541L3.75 8.75C3.07918 9.08541 3.07918 9.08541 3.07918 9.08541L3.07987 9.08679L3.08068 9.08839L3.08266 9.0923L3.08809 9.10285C3.09236 9.11107 3.09794 9.12165 3.10484 9.13444C3.11865 9.16 3.13779 9.19444 3.16241 9.23647C3.2116 9.32045 3.28298 9.43532 3.37776 9.57072C3.56669 9.84062 3.85241 10.1976 4.2455 10.555C5.03662 11.2742 6.2716 12 8 12C9.7284 12 10.9634 11.2742 11.7545 10.555C12.1476 10.1976 12.4333 9.84062 12.6222 9.57072C12.717 9.43532 12.7884 9.32045 12.8376 9.23647C12.8622 9.19444 12.8814 9.16 12.8952 9.13444C12.9021 9.12165 12.9076 9.11107 12.9119 9.10285L12.9173 9.0923L12.9193 9.08839L12.9201 9.08679C12.9201 9.08679 12.9208 9.08541 12.25 8.75L12.9208 9.08541C13.1061 8.71493 12.9559 8.26442 12.5854 8.07918C12.2151 7.89404 11.7649 8.04394 11.5795 8.41399L11.5807 8.4115L11.5753 8.42171C11.5693 8.43277 11.5587 8.45205 11.5433 8.47837C11.5124 8.53111 11.4627 8.61156 11.3934 8.71053C11.2542 8.90938 11.0399 9.17739 10.7455 9.44505C10.1616 9.97585 9.2716 10.5 8 10.5C6.7284 10.5 5.83838 9.97585 5.2545 9.44505C4.96009 9.17739 4.74581 8.90938 4.60661 8.71053C4.53733 8.61156 4.48762 8.53111 4.45673 8.47837C4.44131 8.45205 4.43067 8.43277 4.4247 8.42171L4.41922 8.4114Z",
    fill: "#9E9FA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6Z",
    fill: "#9E9FA1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C9 5.44772 9.44771 5 10 5C10.5523 5 11 5.44772 11 6C11 6.55228 10.5523 7 10 7C9.44771 7 9 6.55228 9 6Z",
    fill: "#9E9FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotSettingsIcon);
export default __webpack_public_path__ + "static/media/botSettingsIcon.d8873005e2d1ece9529e8999cc8346b0.svg";
export { ForwardRef as ReactComponent };